// extracted by mini-css-extract-plugin
export default {"chip":"chip-owK6_","chipProgress":"chipProgress-_Kseo"};